var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$auth.inProgress === 'none' && !_vm.permissionLoading)?_c('router-view'):_c('ProgressIndicator')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }